import canonicalTag from '../helpers/canonicalTag'
import { IKeywordResults } from '../../typings/IKeywordResults'

const DONE = 4
const OK = 200
const keywordUrl = window.$mediavine.web.model.keywordSrc

export default class Keywords {
  private previousUrl: string

  constructor() {
    this.previousUrl = canonicalTag()
  }

  public getResults(): IKeywordResults | void {
    const currentUrl = canonicalTag()
    const { keywords } = window.$mediavine.web

    // sites with infinite scroll will need refreshed keyword data
    if (currentUrl !== this.previousUrl) {
      this.previousUrl = currentUrl
      this.keywordRequest()
    }

    if (keywords) {
      const { sales_cat, sales_evts, sales_kw } = keywords
      return { sales_cat, sales_evts, sales_kw }
    }
  }

  private keywordRequest(): void {
    const request = new XMLHttpRequest()
    request.open('get', `${keywordUrl}?pageUrl=${this.previousUrl}`)
    request.onreadystatechange = this.handleResponse.bind(this, request)
    request.send()
  }

  private handleResponse(request: XMLHttpRequest): void {
    const { readyState, response, status } = request
    const success = readyState === DONE && status === OK
    if (success) {
      const { sales_cat, sales_evts, sales_kw } = JSON.parse(response)
      this.updateKeywords({ sales_cat, sales_evts, sales_kw })
    }
  }

  private updateKeywords(updatedResults: IKeywordResults): void {
    window.$mediavine.web.keywords = updatedResults
  }
}
